import { useMemo } from 'react';

import { createFilterHelper } from '@kc-console/shared-ui';

import type { FilterDefBase } from '@kc-console/shared-ui';

const filterHelper = createFilterHelper();

/**
 * 서비스 상태 테이블의 필터 정의 훅.
 * @description
 * - 서비스 이름을 기준으로 하는 텍스트 프로퍼티 필터를 반환한다.
 * - 리전 필터는 GNB에서 관리하며 URL query string(region)으로 전달된다.
 * @example
 * const filters = useServiceStatusFilters();
 */
const useServiceStatusFilters = (): FilterDefBase[] => {
  return useMemo(
    () => [
      filterHelper.property([
        filterHelper.propertyText({
          id: 'serviceName',
          label: '서비스',
          enableMultiSelect: false,
        }),
      ]),
    ],
    [],
  );
};

export default useServiceStatusFilters;
